import React, { useEffect, useRef, useState } from "react";
import Navbar from "../Components/Navbar";
import "../CSS/testride.css";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { createPuneTestRide, createTestRide } from "../Actions/testrideAction";
import Meta from "../Components/Meta";
import Footer from "../Components/Footer";
import axios from "axios";
import ReactGAA from "react-ga4";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Swiper, SwiperSlide } from "swiper/react";
import bluelogo from "../images/EM-LOGO_Blue.png";
import SwiperCore, {
  Navigation,
  Pagination,
  EffectCoverflow,
  Scrollbar,
  Autoplay,
} from "swiper";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";
import HorizontalDatePicker from "../Components/HorizontalDatePicker";
const PuneTestRideScreen = () => {
  SwiperCore.use([
    Navigation,
    Pagination,
    EffectCoverflow,
    Scrollbar,
    Autoplay,
  ]);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [city, setCity] = useState("Pune");
  const [country, setCountry] = useState("IN");
  const [zip, setZip] = useState("");
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const [utmCampaign, setUtmCampaign] = useState("");
  const [gclid, setGclid] = useState("");
  const [state, setState] = useState("Maharashtra");
  const [addressType, setAddressType] = useState("");
  const [addressLine, setAddressLine] = useState("");

  const analyticEvent = (category, action) => {
    ReactGAA.event({
      category: category,
      action: action,
    });
  };

  useEffect(() => {
    // Fetching UTM campaign parameter from the URL
    const urlParams = new URLSearchParams(window.location.search);
    const campaign = urlParams.get("utm_campaign"); // Get the 'utm_campaign' parameter
    const GClid = urlParams.get("gclid");
    // Set the campaign name in the state
    if (campaign) {
      setUtmCampaign(campaign);
    }
    if (GClid) {
      setGclid(GClid);
    }
  }, []);

  const [isQuestionOne, setIsQuestionOne] = useState(false);
  const [isQuestionTwo, setIsQuestionTwo] = useState(false);
  const [isQuestionThree, setIsQuestionThree] = useState(false);
  const [isQuestionFour, setIsQuestionFour] = useState(false);
  const [isQuestionFive, setIsQuestionFive] = useState(false);
  const [isQuestionSix, setIsQuestionSix] = useState(false);
  const [isQuestionSeven, setIsQuestionSeven] = useState(false);
  const [isQuestionEight, setIsQuestionEight] = useState(false);

  const [isQuestionNine, setIsQuestionNine] = useState(false);

  const toggleQuestionOneCollapse = () => {
    setIsQuestionOne(!isQuestionOne);
  };
  const toggleQuestionTwoCollapse = () => {
    setIsQuestionTwo(!isQuestionTwo);
  };
  const toggleQuestionThreeCollapse = () => {
    setIsQuestionThree(!isQuestionThree);
  };
  const toggleQuestionFourCollapse = () => {
    setIsQuestionFour(!isQuestionFour);
  };
  const toggleQuestionFiveCollapse = () => {
    setIsQuestionFive(!isQuestionFive);
  };
  const toggleQuestionSixCollapse = () => {
    setIsQuestionSix(!isQuestionSix);
  };
  const toggleQuestionSevenCollapse = () => {
    setIsQuestionSeven(!isQuestionSeven);
  };
  const toggleQuestionEightCollapse = () => {
    setIsQuestionEight(!isQuestionEight);
  };
  const toggleQuestionNineCollapse = () => {
    setIsQuestionNine(!isQuestionNine);
  };

  const [step, setStep] = useState(1);
  const [previousStep, setPreviousStep] = useState(0);
  const step1Ref = useRef(null);
  const step2Ref = useRef(null);
  const step3Ref = useRef(null);
  const step4Ref = useRef(null);
  const step5Ref = useRef(null);
  const formRef = useRef(null);

  const handleNext = () => {
    if (formRef.current.checkValidity()) {
      setPreviousStep(1);
      setStep(2);
    } else {
      formRef.current.reportValidity();
    }
  };
  const validateStep = (ref) => {
    const inputs = ref.current.querySelectorAll("input");
    for (let input of inputs) {
      if (!input.reportValidity()) {
        return false;
      }
    }
    return true;
  };
  const nextStep = () => {
    if (step === 2 && validateStep(step2Ref)) {
      setPreviousStep(2);
      setStep(3);
    }
    if (step === 3 && validateStep(step3Ref)) {
      setPreviousStep(3);
      setStep(4);
    }
    if (step === 4 && validateStep(step4Ref)) {
      setPreviousStep(4);
      setStep(5);
    }
  };
  const prevStep = () => setStep((prev) => prev - 1);

  const [slotSelected, setSlotSelected] = useState("");
  const [bikeSelected, setBikeSelected] = useState("");
  const [dateSelected, setDateSelected] = useState("today");

  const timeSlots = [
    "10:00 AM",
    "11:00 AM",
    "12:00 PM",
    "01:00 PM",
    "02:00 PM",
    "03:00 PM",
    "04:00 PM",
    "05:00 PM",
    "06:00 PM",
    "07:00 PM",
  ];

  const bikeData = [
    {
      name: "X1",
      price: "24,999",
      slashPrice: "29,999",
      logo: "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/testRide+Page/pune/Bike+Logos/X1.png",
      image:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/productpage/cardandcartImages/x1b.jpg",
      specs: [
        {
          icon: "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/testRide+Page/pune/Specs+Icons/X1+1.png",
          text: "Commute Up To 35 KM On a Single Charge",
        },
        {
          icon: "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/testRide+Page/pune/Specs+Icons/X1+2.png",
          text: "Charge Anywhere, Anytime Like a Phone",
        },
        {
          icon: "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/testRide+Page/pune/Specs+Icons/X1+3.png",
          text: "Pedal, Accelerate, or Both - Your Choice",
        },
      ],
    },
    {
      name: "X2",
      price: "27,999",
      slashPrice: "34,999",
      logo: "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/testRide+Page/pune/Bike+Logos/X2.png",
      image:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/productpage/cardandcartImages/X2-red.jpg",
      specs: [
        {
          icon: "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/testRide+Page/pune/Specs+Icons/X2+1.png",
          text: "Step-Through Steel Frame For Easy Access",
        },
        {
          icon: "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/testRide+Page/pune/Specs+Icons/X2+2.png",
          text: "100 MM Front Suspension To Glide Over Potholes",
        },
        {
          icon: "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/testRide+Page/pune/Specs+Icons/X2+3.png",
          text: "Mechanical Disc Brakes For Safer Journeys",
        },
      ],
    },
    {
      name: "X3",
      price: "34,999",
      slashPrice: "39,999",
      logo: "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/testRide+Page/pune/Bike+Logos/X3.png",
      image:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/productpage/cardandcartImages/X3+Silver.jpg",
      specs: [
        {
          icon: "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/testRide+Page/pune/Specs+Icons/x3+1.png",
          text: "Puncture Resistant Tyres To Prevent Unexpected Flats",
        },
        {
          icon: "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/testRide+Page/pune/Specs+Icons/x3+2.png",
          text: "Frame-integrated Battery For a stable and balanced ride",
        },
        {
          icon: "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/testRide+Page/pune/Specs+Icons/x3+3.png",
          text: "Ride up to 40 KM On a Single Charge",
        },
      ],
    },
    {
      name: "T-Rex Air",
      price: "34,999",
      slashPrice: "47,999",
      logo: "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/testRide+Page/pune/Bike+Logos/Trex+Air.png",
      image:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/productpage/cardandcartImages/T-Rex%2BAir_CherryRed.jpg",
      specs: [
        {
          icon: "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/testRide+Page/pune/Specs+Icons/Trex+air+1.png",
          text: "Shimano TY300 7-Speed For Seamless Shifting",
        },
        {
          icon: "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/testRide+Page/pune/Specs+Icons/Trex+air+2.png",
          text: "Pedal, Accelerate or Choose from 5 Riding Modes",
        },
        {
          icon: "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/testRide+Page/pune/Specs+Icons/Trex+air+3.png",
          text: "Ride Stat at a Glance with Cluster C5 Display",
        },
      ],
    },
    {
      name: "T-Rex+ V3",
      price: "44,999",
      slashPrice: "59,999",
      logo: "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/testRide+Page/pune/Bike+Logos/Trex+%2B.png",
      image:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/productpage/cardandcartImages/T-REX+%2B+new.png",
      specs: [
        {
          icon: "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/testRide+Page/pune/Specs+Icons/Trex+%2B+1.png",
          text: "Hardtail MTB E-Cycle For Adventurous Rides",
        },
        {
          icon: "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/testRide+Page/pune/Specs+Icons/Trex+%2B+2.png",
          text: "Aluminium Alloy 6061 with Lifetime Warranty",
        },
        {
          icon: "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/testRide+Page/pune/Specs+Icons/Trex+%2B+3.png",
          text: "Integrated LCD Display For All Your Ride Data",
        },
      ],
    },
    {
      name: "T-Rex Pro",
      price: "52,999",
      slashPrice: "74,999",
      logo: "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/testRide+Page/pune/Bike+Logos/Trex+Pro.png",
      image:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/productpage/cardandcartImages/T-Rex+pro+purple.jpg",
      specs: [
        {
          icon: "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/testRide+Page/pune/Specs+Icons/Trex+pro+1.png",
          text: "India’s First Handlebar-Integrated Console",
        },
        {
          icon: "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/testRide+Page/pune/Specs+Icons/Trex+pro+2.png",
          text: "Ride up to 70 KM with 13Ah Removable Battery",
        },
        {
          icon: "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/testRide+Page/pune/Specs+Icons/Trex+pro+3.png",
          text: "Front, Rear Lights, & Indicators To Stay Safe & Visible",
        },
      ],
    },
    {
      name: "STX",
      price: "29,999",
      slashPrice: "34,999",
      logo: "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/testRide+Page/pune/Bike+Logos/STX.png",
      image:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/productpage/cardandcartImages/STX_web_Blue.jpg",
      specs: [
        {
          icon: "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/testRide+Page/pune/Specs+Icons/Stx+1.png",
          text: "Step-Through Steel Frame - Crafted for Everyone",
        },
        {
          icon: "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/testRide+Page/pune/Specs+Icons/Stx+2.png",
          text: "700X40C Nylon Tyres For Smooth Rides",
        },
        {
          icon: "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/testRide+Page/pune/Specs+Icons/Stx+2.png",
          text: "Backsweep Handlebar For a Relaxed Riding Posture",
        },
      ],
    },
    {
      name: "Legend 07",
      price: "29,999",
      slashPrice: "34,999",
      logo: "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/testRide+Page/pune/Bike+Logos/Legend+07.png",
      image:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/productpage/cardandcartImages/x1+legend+card+w.jpg",
      specs: [
        {
          icon: "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/testRide+Page/pune/Specs+Icons/Legend+1.png",
          text: "Ride the Mahi Way With 5 Levels of PAS",
        },
        {
          icon: "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/testRide+Page/pune/Specs+Icons/Legend+2.png",
          text: "Go up to 35 KM On a Single Charge",
        },
        {
          icon: "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/testRide+Page/pune/Specs+Icons/Legend+3.png",
          text: "100 MM Suspension For a Bump-Free Ride",
        },
      ],
    },
    {
      name: "Doodle V3",
      price: "52,999",
      slashPrice: "69,999",
      logo: "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/testRide+Page/pune/Bike+Logos/Doodle+V3.png",
      image:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/productpage/cardandcartImages/doodleNocturnal.jpg",
      specs: [
        {
          icon: "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/testRide+Page/pune/Specs+Icons/Doodle+V3+1.png",
          text: "Foldable Frame For Easy Storage",
        },
        {
          icon: "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/testRide+Page/pune/Specs+Icons/Doodle+V3+2.png",
          text: "Go up to 60 KM with 12.75 Ah Removable Battery",
        },
        {
          icon: "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/testRide+Page/pune/Specs+Icons/Doodle+V3+3.png",
          text: "Nylon Fat Tyres For Enhanced Grip & Stability",
        },
      ],
    },
    {
      name: "Doodle Pro",
      price: "55,999",
      slashPrice: "79,999",
      logo: "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/testRide+Page/pune/Bike+Logos/Doodle+Pro.png",
      image:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/productpage/cardandcartImages/doodleNocturnal.jpg",
      specs: [
        {
          icon: "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/testRide+Page/pune/Specs+Icons/Doodle+pro+1.png",
          text: "See & Be Seen with Bright Front & Rear Light",
        },
        {
          icon: "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/testRide+Page/pune/Specs+Icons/Doodle+pro+2.png",
          text: "Indicators & Hazard Lights For Added Safety",
        },
        {
          icon: "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/testRide+Page/pune/Specs+Icons/Doodle+pro+3.png",
          text: "Foldable Frame—Easy to Carry & Store",
        },
      ],
    },
  ];
  const [showDetails, setShowDetails] = useState(false);
  const handleDateChange = (date) => {
    setDateSelected(date);
  };
  const bookTestride = async (event) => {
    event.preventDefault();
    if (validateStep(step2Ref)) {
      try {
        const pageVisited = "Pune_Testride";
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "lead_form",
          name: name,
          phoneNumber: phoneNumber,
          gclid: gclid,
        });
        const response = await dispatch(
          createPuneTestRide(
            name,
            phoneNumber,
            city,
            country,
            zip,
            addressLine,
            addressType,
            utmCampaign,
            gclid,
            slotSelected,
            bikeSelected,
            dateSelected,
            pageVisited
          )
        );
        analyticEvent("Testride", "Testride Submitted Successfully");
        navigate(`/testride-scheduled`);
      } catch (error) {
        analyticEvent("Testride", "Testride Submission Failed");
        console.error("Error booking test ride:", error);
      }
    }
  };

  return (
    <div id="testridemainpage">
      <Meta
        title={"Book Your Test Ride Now | EMotorad"}
        description={
          "EMotorad brings a range of the best electric bikes that are affordable &amp; futuristic. Crafted with the state of art components, at the best price. Book your test ride now!"
        }
        cannonicalTag={"https://emotorad.com/testride-pune"}
      />
      <div className="w-100 logo-bar">
        <div className=" desktop-nav m-0 p-0 p-3 ps-lg-5 pe-lg-5 ">
          <div className="d-flex justify-content-center ">
            <img
              src={bluelogo}
              className="img-fluid"
              style={{ width: "170px" }}
              alt=""
            />
          </div>
        </div>
      </div>{" "}
      <div className="testRidePuneMainDiv d-none d-lg-block">
        <div
          className="testRidePuneInnerDivDesktop bg-white p-3 rounded-3"
          style={{
            width: "380px",
            boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.2)",
          }}
        >
          <div className=" multistep-form">
            <form ref={formRef}>
              <div
                ref={step1Ref}
                className={`form-slide ${step === 1 ? "active" : "left"}`}
              >
                <h3
                  className="mb-2"
                  style={{ fontFamily: "Metropolis-medium", fontSize: "1em" }}
                >
                  Experience the Thrill of Electric at Home
                </h3>
                <div
                  className="mx-auto mb-4"
                  style={{
                    height: "1px",
                    backgroundColor: "black",
                    width: "100%",
                  }}
                ></div>
                <div className="form-fields-content">
                  <input
                    type="text"
                    className="form-control text-dark w-100 mb-3"
                    required
                    name="username"
                    value={name}
                    autoComplete="off"
                    style={{ background: "none" }}
                    placeholder="Name"
                    pattern="[A-Za-z\s]{2,}"
                    onChange={(e) => {
                      setName(e.target.value);
                      e.target.setCustomValidity("");
                    }}
                    onInvalid={(e) =>
                      e.target.setCustomValidity(
                        "Name should have at least 2 characters and contain only alphabets."
                      )
                    }
                  />
                  <input
                    type="number"
                    name="phoneNumber"
                    className="form-control text-dark w-100 mb-3"
                    required
                    value={phoneNumber}
                    onChange={(e) => {
                      const val = e.target.value.slice(0, 12);
                      setPhoneNumber(val);
                      if (/^[6-9]\d{9}$/.test(val)) {
                        e.target.setCustomValidity("");
                      } else {
                        e.target.setCustomValidity(
                          "Enter a valid phone number (10 digits, starting with 6-9)"
                        );
                      }
                    }}
                    onInvalid={(e) =>
                      e.target.setCustomValidity(
                        "Enter a valid phone number (10 digits, starting with 6-9)"
                      )
                    }
                    placeholder="Phone Number"
                  />
                  <div
                    className="mb-2 text-muted"
                    style={{ fontSize: "0.8em" }}
                  >
                    <small>
                      Disclaimer: By sharing your contact information, you
                      consent to receive calls and emails from us regarding new
                      launches, exclusive offers, and promotions.
                    </small>
                  </div>
                </div>
                <div className="d-flex justify-content-center">
                  <button
                    type="button"
                    style={{ background: "#004dac" }}
                    className=" btn w-75  text-light"
                    onClick={handleNext}
                  >
                    Next
                  </button>
                </div>
              </div>
            </form>
            <form
              className="d-flex justify-content-around"
              onSubmit={bookTestride}
              style={{ flexDirection: "column" }}
            >
              <div
                ref={step2Ref}
                className={`form-slide ${
                  step === 2
                    ? "active"
                    : prevStep === 1 && step > previousStep
                    ? "left"
                    : "right"
                }`}
              >
                <h2
                  className="mb-2"
                  style={{ fontFamily: "Metropolis-medium", fontSize: "1em" }}
                >
                  Choose a Date for Testride:
                </h2>
                <div
                  className="mx-auto mb-4"
                  style={{
                    height: "1px",
                    backgroundColor: "black",
                    width: "100%",
                  }}
                ></div>
                <div className="form-fields-content">
                  <HorizontalDatePicker onDateSelect={handleDateChange} />
                </div>
                <div className="d-flex justify-content-between">
                  <button
                    type="button"
                    className="btn btn-outline-dark"
                    onClick={prevStep}
                  >
                    <Icon
                      icon="ic:twotone-keyboard-arrow-left"
                      width="24"
                      height="24"
                    />
                  </button>
                  <button
                    type="button"
                    style={{ background: "#004dac" }}
                    className=" btn w-75  text-light"
                    onClick={nextStep}
                    disabled={!dateSelected}
                  >
                    Next
                  </button>
                </div>
              </div>
              <div
                ref={step3Ref}
                className={`form-slide ${
                  step === 3
                    ? "active"
                    : prevStep === 2 && step > previousStep
                    ? "left"
                    : "right"
                }`}
              >
                <h2
                  className="mb-2"
                  style={{ fontFamily: "Metropolis-medium", fontSize: "1em" }}
                >
                  Pick a Time Slot:
                </h2>
                <div
                  className="mx-auto mb-4"
                  style={{
                    height: "1px",
                    backgroundColor: "black",
                    width: "100%",
                  }}
                ></div>
                <div className="form-fields-content">
                  <div
                    className="d-flex flex-wrap align-items-center"
                    style={{ gap: "01em" }}
                  >
                    {timeSlots.map((slot, index) => {
                      const isSelected = slot === slotSelected;
                      return (
                        <div
                          key={index}
                          className="time-tab btn px-30"
                          style={{
                            backgroundColor: isSelected ? "#004dac" : "",
                            color: isSelected ? "white" : "",
                            border: isSelected
                              ? "1px solid #004dac"
                              : "1px solid black",
                          }}
                          onClick={() => {
                            setSlotSelected(slot);
                          }}
                        >
                          {slot}
                        </div>
                      );
                    })}
                  </div>
                </div>

                <div className="d-flex justify-content-between">
                  <button
                    type="button"
                    className="btn btn-outline-dark"
                    onClick={prevStep}
                  >
                    <Icon
                      icon="ic:twotone-keyboard-arrow-left"
                      width="24"
                      height="24"
                    />
                  </button>
                  <button
                    type="button"
                    style={{ background: "#004dac" }}
                    disabled={!slotSelected}
                    className=" btn w-75  text-light"
                    onClick={nextStep}
                  >
                    Next
                  </button>
                </div>
              </div>
              <div
                ref={step4Ref}
                className={`form-slide ${
                  step === 4
                    ? "active"
                    : prevStep === 3 && step > previousStep
                    ? "left"
                    : "right"
                }`}
              >
                <h2
                  className="mb-2"
                  style={{ fontFamily: "Metropolis-medium", fontSize: "1em" }}
                >
                  Pick Your E-Cycle Model:
                </h2>
                <div
                  className="mx-auto mb-4"
                  style={{
                    height: "1px",
                    backgroundColor: "black",
                    width: "100%",
                  }}
                ></div>
                <div className="form-fields-content">
                  <Swiper
                    spaceBetween={20}
                    slidesPerView={1.05}
                    initialSlide={0}
                    centeredSlides={true}
                    loop={true}
                    modules={[Pagination, Navigation]}
                    navigation={{ clickable: true }}
                    pagination={{ clickable: true }}
                    simulateTouch={true}
                    slide
                    speed={1000}
                    breakpoints={{
                      1024: {
                        slidesPerView: 1.9,
                        spaceBetween: 15,
                        navigation: true,
                        centeredSlides: true,
                        loop: true,
                        pagination: false,
                        simulateTouch: true,
                      },
                    }}
                  >
                    {bikeData.map((bike, index) => {
                      const isSelected = bike.name === bikeSelected;
                      return (
                        <SwiperSlide>
                          <div
                            className="rounded-3 p-2"
                            style={{
                              height: "200px",
                              border: isSelected
                                ? "1px solid #004dac"
                                : "1px solid grey",
                              cursor: "pointer",
                              backgroundColor: isSelected ? "#F3F9FF" : "",
                            }}
                            onClick={() => {
                              setBikeSelected(bike.name);
                            }}
                          >
                            <div>
                              <div>
                                <div>
                                  <img
                                    src={bike.image}
                                    className="img-fluid my-3"
                                  ></img>
                                </div>
                                <div className="d-flex justify-content-between align-items-end">
                                  <div style={{ width: "35%" }}>
                                    <img
                                      src={bike.logo}
                                      className="img-fluid"
                                    ></img>
                                  </div>
                                  <div>
                                    <p
                                      className="mb-0 metropolis-medium"
                                      style={{ fontSize: "0.75em" }}
                                    >
                                      {bike.price}
                                    </p>
                                    <p
                                      className="mb-0"
                                      style={{
                                        fontSize: "0.65em",
                                        textDecoration: "line-through",
                                      }}
                                    >
                                      {bike.slashPrice}
                                    </p>
                                  </div>
                                </div>
                              </div>

                              {/* <div className="d-flex justify-content-center mt-3">
                              <div className=" btn w-75  text-light btn-dark">
                                Know More
                              </div>
                            </div> */}
                            </div>
                            {/* <div className="pt-5">
                            <div
                              className="d-flex align-items-center mb-3"
                              style={{ gap: "0.4em" }}
                            >
                              <div className="w-25">
                                <img
                                  className="img-fluid"
                                  src={bike.specs[0].icon}
                                ></img>
                              </div>
                              <div>
                                <p
                                  style={{ fontSize: "0.65em" }}
                                  className="mb-0"
                                >
                                  {bike.specs[0].text}
                                </p>
                              </div>
                            </div>
                            <div
                              className="d-flex align-items-center mb-3"
                              style={{ gap: "0.4em" }}
                            >
                              <div className="w-25">
                                <img
                                  className="img-fluid"
                                  src={bike.specs[1].icon}
                                ></img>
                              </div>
                              <div>
                                <p
                                  style={{ fontSize: "0.7em" }}
                                  className="mb-0"
                                >
                                  {bike.specs[1].text}
                                </p>
                              </div>
                            </div>
                            <div
                              className="d-flex align-items-center mb-3"
                              style={{ gap: "0.4em" }}
                            >
                              <div className="w-25">
                                <img
                                  className="img-fluid"
                                  src={bike.specs[2].icon}
                                ></img>
                              </div>
                              <div>
                                <p
                                  style={{ fontSize: "0.65em" }}
                                  className="mb-0"
                                >
                                  {bike.specs[2].text}
                                </p>
                              </div>
                            </div>
                          </div> */}
                          </div>
                        </SwiperSlide>
                      );
                    })}
                  </Swiper>
                </div>
                <div className="d-flex justify-content-between">
                  <button
                    type="button"
                    className="btn btn-outline-dark"
                    onClick={prevStep}
                  >
                    <Icon
                      icon="ic:twotone-keyboard-arrow-left"
                      width="24"
                      height="24"
                    />
                  </button>
                  <button
                    type="button"
                    style={{ background: "#004dac" }}
                    disabled={!bikeSelected}
                    className=" btn w-75  text-light"
                    onClick={nextStep}
                  >
                    Next
                  </button>
                </div>
              </div>
              <div
                ref={step5Ref}
                className={`form-slide ${
                  step === 5
                    ? "active"
                    : prevStep === 4 && step > previousStep
                    ? "left"
                    : "right"
                }`}
              >
                <h2
                  className="mb-2"
                  style={{ fontFamily: "Metropolis-medium", fontSize: "1.3em" }}
                >
                  Add Your Address:
                </h2>
                <div
                  className="mx-auto mb-4"
                  style={{
                    height: "1px",
                    backgroundColor: "black",
                    width: "100%",
                  }}
                ></div>
                <div className="form-fields-content">
                  <div className="px-2">
                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        required
                        name="addressType"
                        id="inlineRadio1"
                        value="Home"
                        checked={addressType === "Home"}
                        onChange={(e) => setAddressType(e.target.value)}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="inlineRadio1"
                      >
                        Home
                      </label>
                    </div>

                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="addressType"
                        id="inlineRadio2"
                        value="Office"
                        checked={addressType === "Office"}
                        onChange={(e) => setAddressType(e.target.value)}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="inlineRadio2"
                      >
                        Office
                      </label>
                    </div>

                    <div className="mt-3">
                      <div>
                        <input
                          type="text"
                          name="Address"
                          placeholder="Address"
                          required
                          autoComplete="new-password"
                          value={addressLine}
                          onChange={(e) => setAddressLine(e.target.value)}
                          className="form-control text-dark w-100 mb-3"
                          id=""
                        />
                      </div>
                    </div>
                    <div className="d-flex mt-3" style={{ gap: "0.6em" }}>
                      <div>
                        <input
                          type="text"
                          pattern="[0-9]*"
                          placeholder="Pin Code*"
                          name="pincode"
                          autoComplete="new-password"
                          required
                          value={zip}
                          onChange={(e) => setZip(e.target.value.slice(0, 6))}
                          className="form-control text-dark w-100 mb-3"
                          id=""
                        />
                      </div>
                      <div>
                        <input
                          value="Pune"
                          required
                          placeholder="City*"
                          className="form-control text-dark w-100 mb-3"
                          type="text"
                          name="city"
                          readonly
                          id=""
                        />
                      </div>
                    </div>
                    <div>
                      <input
                        value="Maharashtra"
                        required
                        placeholder="State*"
                        className="form-control text-dark w-100 mb-3"
                        type="text"
                        name="state"
                        readonly
                        id=""
                      />
                    </div>
                  </div>
                </div>
                <div className="d-flex justify-content-between">
                  <button
                    type="button"
                    className="btn btn-outline-dark"
                    onClick={prevStep}
                  >
                    <Icon
                      icon="ic:twotone-keyboard-arrow-left"
                      width="24"
                      height="24"
                    />
                  </button>
                  <button
                    type="submit"
                    style={{ background: "#004dac" }}
                    className=" btn w-75  text-light"
                    disabled={!bikeSelected}
                  >
                    Book a Test Ride
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className="d-lg-none mb-4">
        <div className="position-relative mb-4">
          <img
            src="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/testRide+Page/pune/Pune+Test+Ride+Mobile.jpg"
            alt=""
            className="img-fluid w-100"
          />
        </div>
        <div
          className="p-3 rounded-3 mx-3"
          style={{ border: "1px solid grey" }}
        >
          <div className=" multistep-form">
            <form ref={formRef} noValidate>
              <div
                ref={step1Ref}
                className={`form-slide ${step === 1 ? "active" : "left"}`}
              >
                <h3
                  className="mb-2"
                  style={{ fontFamily: "Metropolis-medium", fontSize: "1em" }}
                >
                  Experience the Thrill of Electric Cycling at Home
                </h3>
                <div
                  className="mx-auto mb-4"
                  style={{
                    height: "1px",
                    backgroundColor: "black",
                    width: "100%",
                  }}
                ></div>
                <div className="form-fields-content">
                  <input
                    type="text"
                    className="form-control text-dark w-100 mb-3"
                    required
                    value={name}
                    autoComplete="off"
                    style={{ background: "none" }}
                    placeholder="Name"
                    pattern="[A-Za-z\s]{2,}"
                    onChange={(e) => {
                      setName(e.target.value);
                      e.target.setCustomValidity("");
                    }}
                    onInvalid={(e) =>
                      e.target.setCustomValidity(
                        "Name should have at least 2 characters and contain only alphabets."
                      )
                    }
                  />
                  <input
                    type="number"
                    className="form-control text-dark w-100 mb-3"
                    required
                    value={phoneNumber}
                    onChange={(e) => {
                      const val = e.target.value.slice(0, 12);
                      setPhoneNumber(val);
                      if (/^[6-9]\d{9}$/.test(val)) {
                        e.target.setCustomValidity("");
                      } else {
                        e.target.setCustomValidity(
                          "Enter a valid phone number (10 digits, starting with 6-9)"
                        );
                      }
                    }}
                    onInvalid={(e) =>
                      e.target.setCustomValidity(
                        "Enter a valid phone number (10 digits, starting with 6-9)"
                      )
                    }
                    placeholder="Phone Number"
                  />
                  <div
                    className="mb-2 text-muted"
                    style={{ fontSize: "0.8em" }}
                  >
                    <small>
                      Disclaimer: By sharing your contact information, you
                      consent to receive calls and emails from us regarding new
                      launches, exclusive offers, and promotions.
                    </small>
                  </div>
                </div>
                <div className="d-flex justify-content-center">
                  <button
                    type="button"
                    style={{ background: "#004dac" }}
                    className=" btn w-75  text-light"
                    onClick={handleNext}
                  >
                    Next
                  </button>
                </div>
              </div>
            </form>
            <form
              className="d-flex justify-content-around"
              onSubmit={bookTestride}
              style={{ flexDirection: "column" }}
            >
              <div
                ref={step2Ref}
                className={`form-slide ${
                  step === 2
                    ? "active"
                    : prevStep === 1 && step > previousStep
                    ? "left"
                    : "right"
                }`}
              >
                <h2
                  className="mb-2"
                  style={{ fontFamily: "Metropolis-medium", fontSize: "1em" }}
                >
                  Choose a Date for Testride:
                </h2>
                <div
                  className="mx-auto mb-4"
                  style={{
                    height: "1px",
                    backgroundColor: "black",
                    width: "100%",
                  }}
                ></div>
                <div className="form-fields-content">
                  <HorizontalDatePicker onDateSelect={handleDateChange} />
                </div>
                <div className="d-flex justify-content-between">
                  <button
                    type="button"
                    className="btn btn-outline-dark"
                    onClick={prevStep}
                  >
                    <Icon
                      icon="ic:twotone-keyboard-arrow-left"
                      width="24"
                      height="24"
                    />
                  </button>
                  <button
                    type="button"
                    style={{ background: "#004dac" }}
                    className=" btn w-75  text-light"
                    onClick={nextStep}
                    disabled={!dateSelected}
                  >
                    Next
                  </button>
                </div>
              </div>
              <div
                ref={step3Ref}
                className={`form-slide ${
                  step === 3
                    ? "active"
                    : prevStep === 2 && step > previousStep
                    ? "left"
                    : "right"
                }`}
              >
                <h2
                  className="mb-2"
                  style={{ fontFamily: "Metropolis-medium", fontSize: "1em" }}
                >
                  Pick a Time Slot:
                </h2>
                <div
                  className="mx-auto mb-4"
                  style={{
                    height: "1px",
                    backgroundColor: "black",
                    width: "100%",
                  }}
                ></div>
                <div className="form-fields-content">
                  <div
                    className="d-flex flex-wrap align-items-center"
                    style={{ gap: "0.5em" }}
                  >
                    {timeSlots.map((slot, index) => {
                      const isSelected = slot === slotSelected;
                      return (
                        <div
                          key={index}
                          className="time-tab btn px-30"
                          style={{
                            backgroundColor: isSelected ? "#004dac" : "",
                            color: isSelected ? "white" : "",
                            border: isSelected
                              ? "1px solid #004dac"
                              : "1px solid grey",
                          }}
                          onClick={() => {
                            setSlotSelected(slot);
                          }}
                        >
                          {slot}
                        </div>
                      );
                    })}
                  </div>
                </div>

                <div className="d-flex justify-content-between">
                  <button
                    type="button"
                    className="btn btn-outline-dark"
                    onClick={prevStep}
                  >
                    <Icon
                      icon="ic:twotone-keyboard-arrow-left"
                      width="24"
                      height="24"
                    />
                  </button>
                  <button
                    type="button"
                    style={{ background: "#004dac" }}
                    disabled={!slotSelected}
                    className=" btn w-75  text-light"
                    onClick={nextStep}
                  >
                    Next
                  </button>
                </div>
              </div>
              <div
                ref={step4Ref}
                className={`form-slide ${
                  step === 4
                    ? "active"
                    : prevStep === 3 && step > previousStep
                    ? "left"
                    : "right"
                }`}
              >
                <h2
                  className="mb-2"
                  style={{ fontFamily: "Metropolis-medium", fontSize: "1em" }}
                >
                  Pick Your E-Cycle Model:
                </h2>
                <div
                  className="mx-auto mb-4"
                  style={{
                    height: "1px",
                    backgroundColor: "black",
                    width: "100%",
                  }}
                ></div>
                <div className="form-fields-content">
                  <Swiper
                    spaceBetween={20}
                    slidesPerView={1.6}
                    initialSlide={0}
                    centeredSlides={true}
                    loop={true}
                    modules={[Navigation]}
                    simulateTouch={true}
                    slide
                    speed={1000}
                    breakpoints={{
                      1024: {
                        slidesPerView: 1.9,
                        spaceBetween: 15,
                        centeredSlides: true,
                        navigation: true,
                        loop: true,
                        pagination: false,
                        simulateTouch: true,
                      },
                    }}
                  >
                    {bikeData.map((bike, index) => {
                      const isSelected = bike.name === bikeSelected;
                      return (
                        <SwiperSlide>
                          <div
                            className="rounded-3 p-2"
                            style={{
                              height: "220px",
                              border: isSelected
                                ? "1px solid #004dac"
                                : "1px solid grey",
                              cursor: "pointer",
                              backgroundColor: isSelected ? "#F3F9FF" : "",
                            }}
                            onClick={() => {
                              setBikeSelected(bike.name);
                            }}
                          >
                            <div>
                              <div>
                                <div>
                                  <img
                                    src={bike.image}
                                    className="img-fluid my-3"
                                  ></img>
                                </div>
                                <div className="d-flex justify-content-between align-items-end">
                                  <div style={{ width: "35%" }}>
                                    <img
                                      src={bike.logo}
                                      className="img-fluid"
                                    ></img>
                                  </div>
                                  <div>
                                    <p
                                      className="mb-0 metropolis-medium"
                                      style={{ fontSize: "0.75em" }}
                                    >
                                      {bike.price}
                                    </p>
                                    <p
                                      className="mb-0"
                                      style={{
                                        fontSize: "0.65em",
                                        textDecoration: "line-through",
                                      }}
                                    >
                                      {bike.slashPrice}
                                    </p>
                                  </div>
                                </div>
                              </div>

                              {/* <div className="d-flex justify-content-center mt-3">
                              <div className=" btn w-75  text-light btn-dark">
                                Know More
                              </div>
                            </div> */}
                            </div>
                            {/* <div className="pt-5">
                            <div
                              className="d-flex align-items-center mb-3"
                              style={{ gap: "0.4em" }}
                            >
                              <div className="w-25">
                                <img
                                  className="img-fluid"
                                  src={bike.specs[0].icon}
                                ></img>
                              </div>
                              <div>
                                <p
                                  style={{ fontSize: "0.65em" }}
                                  className="mb-0"
                                >
                                  {bike.specs[0].text}
                                </p>
                              </div>
                            </div>
                            <div
                              className="d-flex align-items-center mb-3"
                              style={{ gap: "0.4em" }}
                            >
                              <div className="w-25">
                                <img
                                  className="img-fluid"
                                  src={bike.specs[1].icon}
                                ></img>
                              </div>
                              <div>
                                <p
                                  style={{ fontSize: "0.7em" }}
                                  className="mb-0"
                                >
                                  {bike.specs[1].text}
                                </p>
                              </div>
                            </div>
                            <div
                              className="d-flex align-items-center mb-3"
                              style={{ gap: "0.4em" }}
                            >
                              <div className="w-25">
                                <img
                                  className="img-fluid"
                                  src={bike.specs[2].icon}
                                ></img>
                              </div>
                              <div>
                                <p
                                  style={{ fontSize: "0.65em" }}
                                  className="mb-0"
                                >
                                  {bike.specs[2].text}
                                </p>
                              </div>
                            </div>
                          </div> */}
                          </div>
                        </SwiperSlide>
                      );
                    })}
                  </Swiper>
                </div>
                <div className="d-flex justify-content-between">
                  <button
                    type="button"
                    className="btn btn-outline-dark"
                    onClick={prevStep}
                  >
                    <Icon
                      icon="ic:twotone-keyboard-arrow-left"
                      width="24"
                      height="24"
                    />
                  </button>
                  <button
                    type="button"
                    style={{ background: "#004dac" }}
                    disabled={!bikeSelected}
                    className=" btn w-75  text-light"
                    onClick={nextStep}
                  >
                    Next
                  </button>
                </div>
              </div>
              <div
                ref={step5Ref}
                className={`form-slide ${
                  step === 5
                    ? "active"
                    : prevStep === 4 && step > previousStep
                    ? "left"
                    : "right"
                }`}
              >
                <h2
                  className="mb-2"
                  style={{ fontFamily: "Metropolis-medium", fontSize: "1.3em" }}
                >
                  Add Your Address:
                </h2>
                <div
                  className="mx-auto mb-4"
                  style={{
                    height: "1px",
                    backgroundColor: "black",
                    width: "100%",
                  }}
                ></div>
                <div className="form-fields-content">
                  <div className="px-2">
                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        required
                        name="addressType"
                        id="inlineRadio1"
                        value="Home"
                        checked={addressType === "Home"}
                        onChange={(e) => setAddressType(e.target.value)}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="inlineRadio1"
                      >
                        Home
                      </label>
                    </div>

                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="addressType"
                        id="inlineRadio2"
                        value="Office"
                        checked={addressType === "Office"}
                        onChange={(e) => setAddressType(e.target.value)}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="inlineRadio2"
                      >
                        Office
                      </label>
                    </div>
                    <div className="mt-3">
                      <div>
                        <input
                          type="text"
                          name="Address"
                          placeholder="Address"
                          required
                          autoComplete="new-password"
                          value={addressLine}
                          onChange={(e) => setAddressLine(e.target.value)}
                          className="form-control text-dark w-100 mb-3"
                          id=""
                        />
                      </div>
                    </div>
                    <div className="d-flex mt-3" style={{ gap: "0.6em" }}>
                      <div>
                        <input
                          type="text"
                          pattern="[0-9]*"
                          placeholder="Pin Code*"
                          name="pincode"
                          autoComplete="new-password"
                          required
                          value={zip}
                          onChange={(e) => setZip(e.target.value.slice(0, 6))}
                          className="form-control text-dark w-100 mb-3"
                          id=""
                        />
                      </div>
                      <div>
                        <input
                          value="Pune"
                          required
                          placeholder="City*"
                          className="form-control text-dark w-100 mb-3"
                          type="text"
                          name="city"
                          readonly
                          id=""
                        />
                      </div>
                    </div>

                    <div>
                      <input
                        value="Maharashtra"
                        required
                        placeholder="State*"
                        className="form-control text-dark w-100 mb-3"
                        type="text"
                        name="state"
                        readonly
                        id=""
                      />
                    </div>
                  </div>
                </div>
                <div className="d-flex justify-content-between">
                  <button
                    type="button"
                    className="btn btn-outline-dark"
                    onClick={prevStep}
                  >
                    <Icon
                      icon="ic:twotone-keyboard-arrow-left"
                      width="24"
                      height="24"
                    />
                  </button>
                  <button
                    type="submit"
                    style={{ background: "#004dac" }}
                    className=" btn w-75  text-light"
                    disabled={!bikeSelected}
                  >
                    Book a Test Ride
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div
        className=" position-relative pb-5"
        style={{
          minHeight: "400px",
        }}
      >
        <div
          className="position-relative"
          style={{
            backgroundImage:
              'url("https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/homepage/ABout%2BUs.jpg")',
            backgroundSize: "cover",
            backgroundPosition: "center",
            height: "350px",
          }}
        >
          <div
            className="position-absolute h-100 w-100"
            style={{ background: "rgba(0,0,0,0.6)" }}
          ></div>
          <h3
            className="position-absolute text-light w-100 text-center"
            style={{ fontFamily: "Metropolis-bolder", top: "30%" }}
          >
            “MOST PROMISING EV OF THE YEAR”{" "}
          </h3>{" "}
          <p
            className="text-light mt-1 w-100 text-center celebs-heading text-uppercase"
            style={{ fontSize: "0.9em" }}
          >
            That’s what they said
          </p>
        </div>
        <div className="ps-3" style={{ marginTop: "-5em" }}>
          <Swiper
            spaceBetween={5}
            slidesPerView={1.3}
            autoplay={true}
            loop={true}
            breakpoints={{
              1024: {
                slidesPerView: 6.2,
                spaceBetween: 20,
              },
            }}
            slide
          >
            <SwiperSlide className="p-1 rounded-3">
              <img
                src="https://ar-euro.s3.ap-south-1.amazonaws.com/ind-website-10-23/homepage/clebs/Bhaichung.jpg"
                alt=""
                className="img-fluid"
              />
            </SwiperSlide>
            <SwiperSlide className="p-1 rounded-3">
              <img
                src="https://ar-euro.s3.ap-south-1.amazonaws.com/ind-website-10-23/homepage/clebs/Sonali.jpg"
                alt=""
                className="img-fluid"
              />
            </SwiperSlide>
            <SwiperSlide className="p-1 rounded-3">
              <img
                src="https://ar-euro.s3.ap-south-1.amazonaws.com/ind-website-10-23/homepage/clebs/Isha.jpg"
                alt=""
                className="img-fluid"
              />
            </SwiperSlide>
            <SwiperSlide className="p-1 rounded-3">
              <img
                src="https://ar-euro.s3.ap-south-1.amazonaws.com/ind-website-10-23/homepage/clebs/Jayant.jpg"
                alt=""
                className="img-fluid"
              />
            </SwiperSlide>
            <SwiperSlide className="p-1 rounded-3">
              <img
                src="https://ar-euro.s3.ap-south-1.amazonaws.com/ind-website-10-23/homepage/clebs/Nitin.jpg"
                alt=""
                className="img-fluid"
              />
            </SwiperSlide>{" "}
            <SwiperSlide className="p-1 rounded-3">
              <img
                src="https://ar-euro.s3.ap-south-1.amazonaws.com/ind-website-10-23/homepage/clebs/Shaan.jpg"
                alt=""
                className="img-fluid"
              />
            </SwiperSlide>{" "}
            <SwiperSlide className="p-1 rounded-3">
              <img
                src="https://ar-euro.s3.ap-south-1.amazonaws.com/ind-website-10-23/homepage/clebs/Suniel.jpg"
                alt=""
                className="img-fluid"
              />
            </SwiperSlide>{" "}
            <SwiperSlide className="p-1 rounded-3">
              <img
                src="https://ar-euro.s3.ap-south-1.amazonaws.com/ind-website-10-23/homepage/clebs/Terence.jpg"
                alt=""
                className="img-fluid"
              />
            </SwiperSlide>{" "}
            <SwiperSlide className="p-1 rounded-3">
              <img
                src="https://ar-euro.s3.ap-south-1.amazonaws.com/ind-website-10-23/homepage/clebs/Neha+Dhupia.jpg"
                alt=""
                className="img-fluid"
              />
            </SwiperSlide>{" "}
            <SwiperSlide className="p-1 rounded-3">
              <img
                src="https://ar-euro.s3.ap-south-1.amazonaws.com/ind-website-10-23/homepage/clebs/Angad+Bedi.jpg"
                alt=""
                className="img-fluid"
              />
            </SwiperSlide>{" "}
          </Swiper>
        </div>
      </div>{" "}
    </div>
  );
};

export default PuneTestRideScreen;
